export default __webpack_public_path__ + "static/media/49.6bbd587d.jpg";